var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.166,
    height: 16.379,
    viewBox: "0 0 20.166 16.379",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.093,7.463c.013.179.013.358.013.537A11.679,11.679,0,0,1,6.347,19.759,11.679,11.679,0,0,1,0,17.9a8.55,8.55,0,0,0,1,.051,8.277,8.277,0,0,0,5.131-1.766,4.14,4.14,0,0,1-3.864-2.866,5.212,5.212,0,0,0,.781.064,4.371,4.371,0,0,0,1.088-.141A4.134,4.134,0,0,1,.819,9.19V9.139a4.162,4.162,0,0,0,1.868.525,4.139,4.139,0,0,1-1.28-5.528A11.748,11.748,0,0,0,9.929,8.461a4.666,4.666,0,0,1-.1-.947A4.137,4.137,0,0,1,16.98,4.686a8.137,8.137,0,0,0,2.623-1,4.122,4.122,0,0,1-1.817,2.278,8.285,8.285,0,0,0,2.38-.64A8.884,8.884,0,0,1,18.093,7.463Z",
    transform: "translate(0 -3.381)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.c64e6f21.svg";
export { ForwardRef as ReactComponent };